import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import { StyledLogo } from './Header.styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getUser } from '../Services/OfferService';
import { User } from "oidc-client-ts";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from '@mui/material';
import UserMenu from './UserMenu';
import { AuthService } from '../Services/AuthService';

function Header() {

    const [userInfo, setUserInfo] = useState<User | null>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const getDisplayName = () => {
        const userName = userInfo?.profile?.name;
        const actorName = (userInfo?.profile?.actor as { name?: string })?.name;

        // If there's an actor name, display it alongside the user's name
        if (actorName) {
            return `${userName} (${actorName})`;
        }

        // Default to just the user name
        return userName;
    };

    useEffect(() => {
        async function fetchUser() {
            const user = await getUser();
            if (user === null) {
                navigate("/");
            }
            setUserInfo(user);
        }
        fetchUser();
    }, [navigate]);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const logOut = () => {
        const authService = new AuthService();
        authService.logout();
    };

    const switchUser = () => {
        const authService = new AuthService();
        sessionStorage.removeItem('initialRender');
        authService.login();
    };

    return (
        <AppBar position="static" elevation={0} sx={{ borderBottom: '3px solid', borderColor: 'secondary.main' }}>
            <Toolbar sx={{ width: '100%', maxWidth: 1440, mx: 'auto', gap: 2, justifyContent: 'space-between', minHeight: { xs: 68, sm: 68 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                    <StyledLogo src="https://images.ctfassets.net/8k0h54kbe6bj/3W68zG8kVqVY7DU1qHxVEA/4d403503b05488cc8385578a92ef399e/fiskist-merki_2x.png" alt="Fiskistofa" $isMobile={isMobile} />
                    <Typography variant="h6" component="span" sx={{ fontSize: { xs: '0.9375rem', sm: '1.125rem' } }}>
                        {isMobile ? 'Tilboðsmarkaður' : 'Fiskistofa - Tilboðsmarkaður'}
                    </Typography>
                </Box>
                <Tooltip title="Notandavalmynd">
                    <IconButton onClick={handleOpenUserMenu} color="inherit" aria-label="Notandavalmynd" aria-controls={anchorElUser ? 'menu-appbar' : undefined} aria-haspopup="true" aria-expanded={Boolean(anchorElUser)} sx={{ borderRadius: 2, p: 0.75, gap: 1, flexShrink: 0 }}>
                        <Typography component="span" variant="body2" sx={{ display: { xs: 'none', md: 'block' }, maxWidth: 300, overflowWrap: 'anywhere' }}>{getDisplayName()}</Typography>
                        <Avatar sx={{ width: 32, height: 32, bgcolor: 'rgba(255,255,255,0.16)', color: 'inherit', fontSize: '0.875rem' }}>{userInfo?.profile?.name?.charAt(0) || 'N'}</Avatar>
                        <ExpandMoreIcon sx={{ display: { xs: 'none', sm: 'block' }, fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
                <UserMenu
                    anchorElUser={anchorElUser}
                    handleCloseUserMenu={handleCloseUserMenu}
                    userInfo={userInfo}
                    actorName={(userInfo?.profile?.actor as { name?: string })?.name}
                    logOut={logOut}
                    switchUser={switchUser}
                />
            </Toolbar>
        </AppBar>
    );
}

export default Header;
